/** @format */

import React, { useState } from "react";
import "../../style/news.css";
import "../../style/channel.css";
import { TabView, TabPanel } from "primereact/tabview";
import cloneDeep from "lodash.clonedeep";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import service from "../../utils/service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { BreadCrumb } from "primereact/breadcrumb";
import { Toast } from "primereact/toast";
import HeadBodyGrid from "../common/HeadBody";
import CheckboxList from "../common/CheckboxList";
import AccordionLoader from "../common/AccordionLoader";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";

const NewChannel = ({ setIsNewChannel, addChannel, setDiscardDialog, items, home, newChannelHelper }) => {
  return (
    <form
      id='createChannel'
      onSubmit={(event) => {
        event.preventDefault();
        setIsNewChannel(false);
        addChannel();
      }}
    >
      <BreadCrumb model={items} home={home} style={{ marginBottom: "20px" }} />
      <TabView>
        <TabPanel header='Create New Channel'>{newChannelHelper()}</TabPanel>
      </TabView>

      <Button
        onClick={() => {
          setDiscardDialog(true);
        }}
        label='Discard'
        type='button'
        className='p-button-sm btn3'
      />
      <Button type='submit' form='createChannel' label='Save' className='p-button-sm btn3' />
    </form>
  );
};
const MappingList = ({
  channels,
  channelIndex,
  editIndex,
  setChannelIndex,
  setEditIndex,
  resetChannelData,
  getChannelInfo,
  setChannelRegionIndex,
  setChannelCommodityIndex,
  resetSearchCommodity,
  clearForm,
  setChannelName,
  populateForm,
  channelData,
  getRowsPerPage,
  regions,
  editChannel,
  onPage,
  setDiscardDialog,
  channelLoading,
  newChannelHelper, // later change to Component
  ...rest
}) => {
  const { isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isSuperAdminRole, isCornRole } = rest;
  return (
    <div>
      <div style={{ marginTop: "1.5rem" }}>
        {channelLoading && <AccordionLoader />}
        {channels.map((channel, index) => {
          let isChannelDisabled = false;
          if (!isSuperAdminRole) {
            if (channel.channelName === BUSINESS_UNIT.ANIMAL_FEED && !isAnimalFeedRole) {
              isChannelDisabled = true;
            }
            if (channel.channelName === BUSINESS_UNIT.EDIBLE_OILS && !isEdibleOilsRole) {
              isChannelDisabled = true;
            }
            if (channel.channelName === BUSINESS_UNIT.GRAINS && !isGrainsRole) {
              isChannelDisabled = true;
            }
            if (channel.channelName === BUSINESS_UNIT.CORN && !isCornRole) {
              isChannelDisabled = true;
            }
            if (channel.channelName === BUSINESS_UNIT.COCOA && !isCocoaRole) {
              isChannelDisabled = true;
            }
          }
          return (
            <div className='grid' key={index}>
              <div className='col-fixed' style={{ width: "80px" }}>
                <div style={{ opacity: isChannelDisabled ? "0.5" : "1" }} className='box1 text-center'>
                  {index + 1}
                </div>
              </div>
              <div className='col'>
                <div className='box' style={{ opacity: isChannelDisabled ? "0.5" : "1" }}>
                  {channel.channelName}
                  <span
                    onClick={(e) => {
                      if (isChannelDisabled) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                      }
                      if (channelIndex === index) {
                        setChannelIndex(-1);
                        setEditIndex(-1);
                      } else {
                        resetChannelData();
                        setEditIndex(-1);
                        getChannelInfo(channel.channelId);
                        setChannelIndex(index);
                      }
                      setChannelRegionIndex(0);
                      setChannelCommodityIndex(0);
                      resetSearchCommodity();
                    }}
                    className='floatRight'
                  >
                    {channelIndex === index ? (
                      <i className='pi pi-chevron-up'></i>
                    ) : (
                      <i className='pi pi-chevron-down'></i>
                    )}
                  </span>

                  {channelIndex === index && (
                    <span
                      onClick={() => {
                        clearForm();
                        setChannelName(channel.channelName);
                        populateForm(channel.channelId);
                        setEditIndex(index);
                      }}
                      className='expand'
                    >
                      Edit
                    </span>
                  )}
                  {channelIndex === index && editIndex === -1 && (
                    <div className='seperatorContent'>
                      <TabView>
                        <TabPanel header='Region'>
                          <DataTable
                            value={channelData.data}
                            className='p-datatable-striped'
                            // scrollable
                            // scrollHeight="300px"
                            paginatorTemplate='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
                            paginator
                            currentPageReportTemplate='Showing {first} to {last} of {totalRecords}'
                            rows={channelData.rowsPerPage}
                            rowsPerPageOptions={getRowsPerPage(channelData.totalRecords)}
                            lazy
                            loading={channelData.isOpening}
                            totalRecords={channelData.totalRecords.length}
                            onPage={onPage}
                            first={channelData.firstPage}
                          >
                            {regions.map((region, index) => (
                              <Column field={region.region} key={index} header={region.region}></Column>
                            ))}
                          </DataTable>
                        </TabPanel>
                      </TabView>
                    </div>
                  )}
                  {channelIndex === index && editIndex === index && (
                    <div className='seperatorContent'>
                      <form
                        id='editChannel'
                        onSubmit={(event) => {
                          event.preventDefault();
                          setEditIndex(-1);
                          setChannelIndex(-1);
                          editChannel(channel.channelId);
                        }}
                      >
                        {newChannelHelper()}
                        <Button
                          onClick={() => {
                            setDiscardDialog(true);
                          }}
                          type='button'
                          label='Discard'
                          className='btn3'
                        />
                        <Button type='submit' form='editChannel' label='Save' className='btn3' />
                        <div className='clear'></div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
function Channel(props) {
  const [isNewChannel, setIsNewChannel] = useState(false);
  const [commodities, setCommodities] = useState([]);
  const [craCommodities, setCraCommodities] = useState([]);
  const [editLoading, setEditLoading] = useState(false);
  const toast = React.useRef(null);
  const [regionCommodityData, setRegionCommodityData] = useState({});
  const [editIndex, setEditIndex] = React.useState(-1);
  const [channelRegionIndex, setChannelRegionIndex] = React.useState(0);
  const [channelCommodityIndex, setChannelCommodityIndex] = React.useState(0);
  const [dragCommodity, setDragCommodity] = React.useState({});
  const [fromRegionId, setFromRegionId] = React.useState(null);
  const [dragInRegion, setDragInRegion] = React.useState(null);

  const [filteredCommodities, setFilteredCommodities] = useState(commodities);
  const [filteredCraCommodities, setFilteredCraCommodities] = useState(craCommodities);

  const [regions, setRegions] = useState([]);

  const handleDrop = (region) => {
    setRegionCommodityData((prevData) => {
      for (var i = 0; i < regionCommodityData[region].length; i++) {
        if (regionCommodityData[region][i].commodityId === dragCommodity.commodityId) return prevData;
      }
      return {
        ...prevData,
        [region]: [...prevData[region], dragCommodity],
      };
    });
  };

  const handleDropToRemove = () => {
    if (fromRegionId !== null) {
      let temp = regionCommodityData[fromRegionId];
      const index = temp.indexOf(dragCommodity);
      if (index > -1) {
        temp.splice(index, 1);
        setRegionCommodityData((prevData) => {
          return {
            ...prevData,
            [fromRegionId]: temp,
          };
        });
      }
    }
  };

  const [channels, setChannels] = useState([]);
  const [channelLoading, setChannelLoading] = useState(true);

  const [channelIndex, setChannelIndex] = useState(-1);
  const [channelData, setChannelData] = React.useState(() => {
    const ROWS_PER_PAGE_CONST = 5;
    return {
      data: [],
      regions: [],
      totalRecords: [],
      isOpening: false,
      firstPage: 0,
      rowsPerPage: ROWS_PER_PAGE_CONST,
      ROWS_PER_PAGE_CONST,
    };
  });

  const resetChannelData = () => {
    setChannelData((chData) => ({
      ...chData,
      data: [],
      regions: [],
      totalRecords: [],
      isOpening: false,
      firstPage: 0,
      rowsPerPage: chData.ROWS_PER_PAGE_CONST,
    }));
  };

  const getChannelInfo = (Id) => {
    setChannelData((chData) => ({
      ...chData,
      isOpening: true,
    }));
    service
      .getChannelById(Id)
      .then((request) => {
        var len = 0;
        const regionResponse = request.data.regionResponseDTOS;
        const channelRegions = regions.filter((region) => regionResponse.find((reg) => reg.region === region.region));
        for (var i = 0; i < regionResponse.length; i++) {
          len = Math.max(len, regionResponse[i].commodityResponseDTOS.length);
        }
        let temp = [];
        for (i = 0; i < len; i++) {
          temp.push({});
        }
        for (i = 0; i < regionResponse.length; i++) {
          for (var j = 0; j < regionResponse[i].commodityResponseDTOS.length; j++) {
            temp[j][regionResponse[i].region] = regionResponse[i].commodityResponseDTOS[j].commodityName;
          }
        }
        setChannelData((chData) => ({
          ...chData,
          data: temp,
          regions: channelRegions,
          totalRecords: temp,
          isOpening: false,
          firstPage: 0,
          rowsPerPage: 5,
        }));
      })
      .catch((err) => {
        setChannelData((chData) => ({
          ...chData,
          isOpening: false,
        }));
      });
  };

  function onPage(event) {
    setChannelData((chData) => ({
      ...chData,
      isOpening: true,
    }));
    const { first, rows } = event;
    setChannelData((chData) => ({
      ...chData,
      data: chData.totalRecords.slice(first, first + rows),
      firstPage: first,
      rowsPerPage: rows,
      isOpening: false,
    }));
  }

  const populateForm = (Id) => {
    setEditLoading(true);
    service
      .getChannelById(Id)
      .then((request) => {
        const regionResponse = request.data.regionResponseDTOS;
        const channelRegions = regions.filter((region) => regionResponse.find((reg) => reg.region === region.region));
        var temp = {};
        // for(var i=0;i<regions.length; i++){
        //   temp[regions[i].regionId] = []
        // }
        for (let i = 0; i < regionResponse.length; i++) {
          let regionId = 2;
          for (var j = 0; j < channelRegions.length; j++) {
            if (regionResponse[i].region === channelRegions[j].region) regionId = channelRegions[j].id;
          }
          for (j = 0; j < regionResponse[i].commodityResponseDTOS.length; j++) {
            if (temp[regionId]) {
              temp[regionId].push(regionResponse[i].commodityResponseDTOS[j]);
            } else {
              temp[regionId] = [regionResponse[i].commodityResponseDTOS[j]];
            }
          }
        }

        setRegionCommodityData(temp);
        setEditLoading(false);
      })
      .catch((err) => setEditLoading(false));
  };

  const [discardDialog, setDiscardDialog] = useState(false);

  const createChannelJSON = () => {
    var channelJSON = {};
    channelJSON.channelName = channelName;
    channelJSON.regionRequestDTOS = [];
    for (var i = 0; i < regions.length; i++) {
      let regionId = regions[i].id;
      let commodityData = regionCommodityData[regionId];
      if (commodityData && commodityData.length !== 0) {
        var temp = {};
        temp.regionId = regionId;
        temp.commodityRequestDTOS = [];
        for (var j = 0; j < regionCommodityData[regionId].length; j++) {
          var commodity = {
            commodityId: regionCommodityData[regionId][j].commodityId,
          };
          temp.commodityRequestDTOS.push(commodity);
        }
        channelJSON.regionRequestDTOS.push(temp);
      }
    }
    return channelJSON;
  };

  var clearForm = () => {
    setChannelName("");
    var temp = {};
    for (var i = 0; i < regions.length; i++) {
      temp[regions[i].id] = [];
    }
    setRegionCommodityData(temp);
  };

  const addChannel = () => {
    var channelJSON = createChannelJSON();
    service
      .saveCommodityChannel(channelJSON)
      .then(() => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "New Channel created successfully",
          life: 3000,
        });
        getChannels();
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error while creating new channel",
          life: 3000,
        });
        console.error(error);
      });
    clearForm();
  };

  const editChannel = (channelId) => {
    var channelJSON = createChannelJSON();
    channelJSON.channelId = channelId;
    service
      .editCommodityChannel(channelJSON)
      .then(() => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Selected Channel edited successfully",
          life: 3000,
        });
        getChannels();
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error while editing the channel",
          life: 3000,
        });
        console.error(error);
      });
    clearForm();
  };

  const resetSearchCommodity = (evt) => {
    setFilteredCraCommodities(craCommodities);
    setFilteredCommodities(commodities);
  };

  const searchCommodity = (str, flg = 0) => {
    str = str.toLowerCase();
    if (flg) {
      setFilteredCraCommodities(craCommodities.filter((commodity) => commodity.commodity.toLowerCase().includes(str)));
    } else {
      setFilteredCommodities(commodities.filter((commodity) => commodity.commodityName.toLowerCase().includes(str)));
    }
  };

  const [channelName, setChannelName] = React.useState("");
  const items = [
    { label: "Channel", url: "/channel" },
    {
      label: "Add Channel",
    },
  ];

  const home = {
    icon: "pi pi-home",
    url: "/",
  };
  const newChannelHelper = () => {
    const channelRegions = regions.filter((region) => Object.keys(regionCommodityData).includes(region.id + ""));
    const regionsToAdd = regions.filter((region) => !channelRegions.find((cr) => cr.id === region.id));
    const channelRegionIds = channelRegions.map((ch) => ch.id);
    const isCocoaChannel = channelName && channelName.trim().toLocaleLowerCase() === "cocoa";
    return (
      <div>
        <div className='p-fluid formgrid grid'>
          <div className='field col-12 md:col-3'>
            <label htmlFor='channelName'>Channel Name</label>
            <InputText
              id='channelName'
              value={channelName}
              type='text'
              onChange={(event) => {
                setChannelName(event.target.value);
              }}
              required
              keyfilter={/^[a-zA-Z ]+/gm}
              maxLength={50}
            />
          </div>
        </div>
        <TabView
          activeIndex={channelRegionIndex}
          onTabChange={(evt) => {
            setChannelRegionIndex(evt.index);
            resetSearchCommodity();
          }}
        >
          <TabPanel header='Region'>
            <div className='flex align-items-center'>
              <label className='p-disabled'>Select Your Filter</label>
              {editLoading && regions.map((region) => <CheckboxList key={region.id} />)}
              {!editLoading &&
                regions.map((region, index) => {
                  return (
                    <div className='ml-5' key={region.id}>
                      <Checkbox
                        className='dark-checkbox'
                        checked={channelRegionIds.includes(region.id)}
                        disabled={channelRegionIds.includes(region.id) && regionsToAdd.length === regions.length - 1}
                        inputId={`${region.region}-${region.id}`}
                        value={region.id}
                        onChange={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          let clonedRegionCommodityData = cloneDeep(regionCommodityData);
                          if (e.checked) {
                            clonedRegionCommodityData[e.value] = [];
                          } else {
                            delete clonedRegionCommodityData[e.value];
                          }
                          setRegionCommodityData(clonedRegionCommodityData);
                        }}
                      />
                      <label htmlFor={`${region.region}-${region.id}`} className='p-checkbox-label'>
                        {region.region}
                      </label>
                    </div>
                  );
                })}
              <Button
                disabled={regionsToAdd.length === 0}
                label='Select all'
                className='ml-auto btn3'
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const newRegions = regionsToAdd.reduce((prev, curr) => {
                    prev[curr.id] = [];
                    return prev;
                  }, {});
                  setRegionCommodityData((prevReg) => {
                    return {
                      ...prevReg,
                      ...newRegions,
                    };
                  });
                }}
              />
            </div>
            <div className='grid'>
              {editLoading &&
                channelRegions.map((region, index) => (
                  <div key={region.id} className='col-3'>
                    <HeadBodyGrid />
                  </div>
                ))}
              {!editLoading &&
                channelRegions.map((region, index, channelRegionsArr) => (
                  <div key={region.id} className='col'>
                    <h4 className='regionHeader'>
                      {region.region}
                      {channelRegionsArr.length !== 1 && (
                        <i
                          className='pi pi-times'
                          style={{ float: "right", color: "#252525" }}
                          onClick={() => {
                            setRegionCommodityData((prevReg) => {
                              const { [region.id]: toRemove, ...rest } = prevReg;
                              return {
                                ...rest,
                              };
                            });
                            // setDragCommodity(commodity)
                            // setFromRegionId(region.id)
                            // handleDropToRemove()
                          }}
                        />
                      )}
                    </h4>
                    <div
                      style={{
                        height: "250px",
                        border: "1px solid #d1d0cf",
                        overflowY: "auto",
                        borderRadius: "4px",
                      }}
                      key={index}
                      onDragOver={(event) => {
                        event.preventDefault();
                        setDragInRegion(region);
                      }}
                      onDrop={() => handleDrop(region.id)}
                    >
                      {regionCommodityData[region.id].map((commodity, index) => (
                        <div
                          className='grid-item'
                          key={index}
                          draggable
                          onDragStart={() => {
                            setDragCommodity(commodity);
                            setFromRegionId(region.id);
                          }}
                          style={
                            region === dragInRegion && commodity.commodityId === dragCommodity.commodityId
                              ? { visibility: "hidden" }
                              : {}
                          }
                          onDragEnd={() => {
                            setDragInRegion(null);
                          }}
                          onDragOver={(e) => {
                            e.preventDefault();
                            if (dragCommodity.commodityId === commodity.commodityId) {
                              return;
                            }
                            setRegionCommodityData((prevData) => {
                              let items = prevData[region.id].filter(
                                (item) => item.commodityId !== dragCommodity.commodityId
                              );
                              items.splice(index, 0, dragCommodity);
                              return {
                                ...prevData,
                                [region.id]: items,
                              };
                            });
                          }}
                        >
                          {commodity.commodityName}
                          <i
                            className='pi pi-times'
                            style={{ float: "right", color: "#d1d0cf" }}
                            onClick={() => {
                              setDragCommodity(commodity);
                              setFromRegionId(region.id);
                              handleDropToRemove();
                            }}
                          ></i>
                          <div className='clear'></div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
            <div style={{ marginTop: "1rem" }}>*ANF - Animal Feed Commodities</div>
          </TabPanel>
        </TabView>

        <p className='drag-description'>Drag and drop the commodity from below table</p>
        <div
          style={{ border: "1px solid #d1d0cf", padding: "1rem" }}
          onDragOver={(event) => event.preventDefault()}
          onDrop={() => handleDropToRemove()}
        >
          <TabView
            activeIndex={channelCommodityIndex}
            onTabChange={(evt) => {
              setChannelCommodityIndex(evt.index);
              resetSearchCommodity();
            }}
          >
            <TabPanel header='Commodity'>
              <InputText
                style={{ margin: "1rem 0rem 1rem 0rem" }}
                placeholder='Search Commodity'
                onChange={(event) => searchCommodity(event.target.value, 0)}
              />
              <div className='grid-container'>
                {filteredCommodities.map((commodity, index) => (
                  <div
                    className='grid-item p-text-wrap'
                    onDragStart={() => {
                      setDragCommodity(commodity);
                      setFromRegionId(null);
                    }}
                    onDragEnd={() => {
                      setDragInRegion(null);
                    }}
                    draggable
                    key={index}
                  >
                    {commodity.commodityName}
                  </div>
                ))}
              </div>
              <div style={{ marginTop: "1rem" }}>*ANF - Animal Feed Commodities</div>
            </TabPanel>

            <TabPanel disabled={!isCocoaChannel} header={isCocoaChannel ? "CRA Commodity" : ""}>
              <InputText
                style={{ margin: "1rem 0rem 1rem 0rem" }}
                placeholder='Search Commodity'
                onChange={(event) => searchCommodity(event.target.value, 1)}
              />
              <div className='grid-container'>
                {filteredCraCommodities.map((commodity, index) => (
                  <div className='grid-item p-text-wrap' key={index}>
                    {commodity.name}
                  </div>
                ))}
              </div>
              {/* <div style={{marginTop: "1rem"}}>*ANF - Animal Feed Commodities</div> */}
            </TabPanel>
          </TabView>
        </div>
        <div style={{ margin: "2rem" }}></div>
      </div>
    );
  };

  const getRowsPerPage = (data) => {
    const limit = Math.ceil(data.length / channelData.ROWS_PER_PAGE_CONST);
    return Array(limit)
      .fill("")
      .map((v, i) => (i + 1) * 5);
  };

  const getChannels = () => {
    service
      .getChannels()
      .then((request) => {
        const activeChannels = request.data.filter((d) => d.status === "ACTIVE");
        setChannels(activeChannels);
      })
      .finally(() => setChannelLoading(false));
  };

  React.useEffect(() => {
    service.cra.getCraCommodities().then((request) => {
      setCraCommodities(request.data);
      setFilteredCraCommodities(request.data);
    });
    service.getChannelCommodities().then((request) => {
      setCommodities(request.data);
      setFilteredCommodities(request.data);
    });
    service.getChannelRegions().then((request) => {
      var temp = {};
      for (var i = 0; i < request.data.length; i++) {
        temp[request.data[i].id] = [];
      }
      setRegionCommodityData(temp);
      setRegions(request.data);
    });
    getChannels();
  }, []);
  return (
    <div className='main-box'>
      <Toast ref={toast} baseZIndex={20000} />
      <div>
        {isNewChannel ? (
          <NewChannel
            setIsNewChannel={setIsNewChannel}
            addChannel={addChannel}
            setDiscardDialog={setDiscardDialog}
            newChannelHelper={newChannelHelper}
            items={items}
            home={home}
          />
        ) : (
          <>
            <Button
              label='Add New Channel'
              className='p-button-sm btn3'
              onClick={() => {
                clearForm();
                setChannelCommodityIndex(0);
                setIsNewChannel(true);
              }}
            />
            <div style={{ clear: "both" }}>
              <MappingList
                channels={channels}
                channelIndex={channelIndex}
                editIndex={editIndex}
                setChannelIndex={setChannelIndex}
                setEditIndex={setEditIndex}
                resetChannelData={resetChannelData}
                getChannelInfo={getChannelInfo}
                setChannelRegionIndex={setChannelRegionIndex}
                setChannelCommodityIndex={setChannelCommodityIndex}
                resetSearchCommodity={resetSearchCommodity}
                clearForm={clearForm}
                setChannelName={setChannelName}
                populateForm={populateForm}
                channelData={channelData}
                getRowsPerPage={getRowsPerPage}
                regions={regions}
                editChannel={editChannel}
                onPage={onPage}
                setDiscardDialog={setDiscardDialog}
                newChannelHelper={newChannelHelper}
                {...props}
                channelLoading={channelLoading}
                {...props}
              />
            </div>
          </>
        )}
      </div>
      <Dialog
        baseZIndex={10001}
        header='Discard Confirmation'
        visible={discardDialog}
        style={{ width: "50vw" }}
        onHide={() => setDiscardDialog(false)}
        focusOnShow={false}
      >
        <p className='m-0'>Are you sure you want to discard your changes?</p>
        <div className='spacing1'>
          <Button label='Cancel' onClick={() => setDiscardDialog(false)} className='p-button p-button-sm btn3' />
          <Button
            label='Confirm'
            onClick={() => {
              clearForm();
              setIsNewChannel(false);
              setEditIndex(-1);
              setChannelIndex(-1);
              setDiscardDialog(false);
            }}
            autoFocus
            className='p-button p-button-sm btn3'
          />
        </div>
      </Dialog>
    </div>
  );
}

export default Channel;
